import React from 'react';
import AboutSection from '../components/AboutSection';

const AboutPage = () => {
  return (
    <div className="about-page">
      <AboutSection />
    </div>
  );
};

export default AboutPage;
